import React, { FC, useContext } from 'react';

import { DecisionEngineQueries }                 from '../../../../../queries';
import { Uuid }                                  from '../../../../../types';
import { useFeatureFlags, useProjectObjectives } from '../../../../../hooks';
import { ACTIVITY_STATUS }                       from '../../../../../constants/ProductEnums';
import { InlineLoadingIndicatorLabel }           from '../../../../components/util/loading/InlineLoadingIndicatorLabel';
import { ItemFromQuery }                         from '../../../../components/from-query/ItemFromQuery';
import { TagCloud, TagCloudProps }               from '../../../../components/tag/TagCloud';
import { ProjectContext }                        from '../../ProjectIndexPage';
import { maybeStaticVersionField }               from "@src/util";


interface Props extends Omit<TagCloudProps, 'tags'> {
    id: Uuid
}

const defaultProps: Props = {
    id: null
}

const ObjectiveDetailRelatedProjectActivityTagCloud: FC<Props> = ( props ) => {

    let { id, ...tagCloudProps }       = props,
        { projectId, isCorvalManaged } = useContext( ProjectContext ),
        { getObjectiveTags }           = useProjectObjectives( projectId ),
        featureFlags                   = useFeatureFlags();

    if( !featureFlags.enableProjectActivityMetatagViewsAndTools ) return null;

    return (

        <ItemFromQuery
            query={ DecisionEngineQueries.queries.GET_PROJECT_ACTIVITIES( `
				id
				activity{ id displayName tags { tagName } }
			` ) }
            queryOptions={ {
                variables: {
                    projectId,
                    where: {
                        and: [
                            { subObjectiveId: { eq: id } },
                            { completionState: { neq: ACTIVITY_STATUS.EXCLUDED } }
                        ]
                    }
                },

                // since statuses my change, we need to not rely on cache here.
                fetchPolicy: 'network-only'
            } }
            queryResultObject={ data => {

                const projectActivitiesField = maybeStaticVersionField( 'projectActivities', !isCorvalManaged )

                return getObjectiveTags( data[ projectActivitiesField ] );

            } }
            loadingComponent={ () => <InlineLoadingIndicatorLabel label={ 'Loading tags...' }/> }
            noItemsComponent={ () => null }>

            { tags => <TagCloud tags={ tags } { ...tagCloudProps }/> }

        </ItemFromQuery>
    );
};

ObjectiveDetailRelatedProjectActivityTagCloud.defaultProps = defaultProps;

export { ObjectiveDetailRelatedProjectActivityTagCloud }
